

































































import {SERVER_HOST_QR} from '@/config';
import {Component, Prop, Vue} from 'vue-property-decorator';
import axios from 'axios';

@Component({
  name: "QrStand"
})
export default class QrStand extends Vue {
  @Prop({type: String, default: null}) show!: string | null
  @Prop({type: String, default: null}) params!: string | null
  items: any = []

  TranslateType(str:string){
    let val:string = ''
    switch (str){
      case 'phone':
        val =  'Телефон'
        break;
      case 'email':
        val =  'Email'
        break;
      case 'site':
        val =  'Сайт'
        break;
    }
    return val
  }

  async getDataFromServer() {
    try {
      this.$emit('setLoading', true)
      const {data} = await axios.get(SERVER_HOST_QR + 'show/' + this.show + '/stand/' + this.params + '/company')
      if (data.status != 'err') {
        this.items = data
        this.$emit('addItemsFromStorage',
          {
            path: this.$route.path,
            obj:{
              type:'stand',
              title: this.params,
              company:data
            }
          })
      } else {
        this.$emit('showError')
      }
    } catch (e) {
      this.$emit('showError')
      console.log(e)
    }
  }

  mounted() {
    this.getDataFromServer()
  }
}
